import type { AnyAction } from "redux";

import type { INavItem } from "app/components/React/SideNavComponents/SideNav.types";

import { navObj } from "../config/dashboardNavObj";
import { SET_SIDE_NAV_ITEMS } from "../DashboardSideNavActionTypes";

export interface IDashboardSideNavState {
    navList: INavItem[];
    navListLoaded: boolean;
}

const DEFAULT_DASHBOARD_SIDE_NAV_STATE: IDashboardSideNavState = { navList: [], navListLoaded: false };

export default function dashboardSideNavReducer(
    state: IDashboardSideNavState = DEFAULT_DASHBOARD_SIDE_NAV_STATE,
    action: AnyAction,
): IDashboardSideNavState {
    switch (action.type) {
        case SET_SIDE_NAV_ITEMS:
            return {
                ...state,
                navListLoaded: action.navListLoaded,
                navList: [...navObj({ sharedWithMeDashboards: action.sharedWithMeDashboards }).navList],
            };
        default:
            return state;
    }
}
